// extracted by mini-css-extract-plugin
export var link = "_rr-0";